<jhi-custom-box [title]="'spans.homepage.boxtitle'"
                [subTitle]="'spans.homepage.welcome'"
                [boxSize]="'box-620'"
                [contentLoading]="loading">
    <!-- User Type Display -->
    <div class="user-type-info mb-3" *ngIf="isUserLogged && userTypeDisplay && user?.showUserTypeDisplay">
        <div class="alert alert-info" role="alert">
            <i class="fa fa-user" aria-hidden="true"></i>
            <strong>Tipo utente:</strong> {{ userTypeDisplay }}
        </div>
    </div>
    
    <div class="home-links">
          <!-- Links are publicly visible; server enforces access rules on navigation -->
          <a routerLink="" (click)="getRedirect('/cambiaPassword')"
              jhiTranslate="spans.homepage.links.changepassword"></a>
          <br/>

          <a class="m-t-15-sm" routerLink="passwordDimenticata" routerLinkActive="active"
              jhiTranslate="spans.homepage.links.forgotpassword"></a>
          <br/>

          <a class="m-t-15-sm" routerLink="usernameDimenticato" routerLinkActive="active"
              jhiTranslate="spans.homepage.links.forgotusername"></a>
          <br/>

          <a routerLink="" class="m-t-15-sm" (click)="getRedirect('/modificaInformazioni')"
              jhiTranslate="spans.homepage.links.editinfo"></a>
          <br/>
        
        <!-- PIN change only for DAG organization, feature enabled and not eIDAS users -->
        <div *ngIf="orgDag && !isEidasUser() && user?.pinEnabled">
            <a  routerLink="" class="m-t-15-sm" (click)="getRedirect('/cambiaPin')"
               jhiTranslate="spans.homepage.links.changepin"></a>
        </div>
    </div>
    <div class="d-flex" *ngIf="appUrl">
        <button type="button" class="btn secondary-btn ml-auto mr-auto" (click)="backToApp()" jhiTranslate="buttons.returntoapp">Return to application
        </button>
    </div>
</jhi-custom-box>
